module.exports = __webpack_public_path__ + "img/17.6f6f88d8.png";